import OperationsPage from './OperationsPage';

export default OperationsPage;
